export class ProjectRequest { 
    public projectName: string;
}